import { Route } from '@angular/router';

/**
 * Pinpad app routes. Main screens mount from the shell (`view.View`);
 * staff login / place picker / home do not use the Angular Router.
 */
export const appRoutes: Route[] = [];
